import { IRootState } from "../../../types/redux/IRootStore";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/hooks";
import { closeModalRedux as closeModal, setModified, showModalWithPalletsByGuid } from "../../../redux/slices/modalPallets2.feature";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";
import React from "react";
import { translateString } from "../../../translations/gridTranslationHelper";
import { tryCatchBootbox } from "../../../aplApi/apiTryCatch";
import { returnPallet } from "../../../aplApi/consumptionHelper";
import { Guid } from "guid-typescript";
import { getActivityAndConsumptionDetailsByOperationIdRedux } from "../../../redux/slices/consumptionDetails.feature";
import { ModalType } from "./types/modalType";

export default function ModalConsumptionReturn() {
    const modalPltsRedux = useSelector((state: IRootState) => state.modalPallets2);
    const consRedux = useSelector((state: IRootState) => state.consumptionDetails)
    const aplSettings = AplSettingsSelector();
    const dispatch = useAppDispatch();

    const [qtyRemaining, setQtyRemaining] = React.useState<number>(0);
    const actualQty = modalPltsRedux.pallets.length === 1 ? modalPltsRedux.pallets[0].actualQty : 0;
    const updateByConsumed = (value: number) => setQtyRemaining(value >= actualQty ? 0 : actualQty - value);
    const updateByRemaining = (value: number) => setQtyRemaining(value >= actualQty ? actualQty : value);
    const consumptionId = consRedux.selectedConsumptionDetails.length === 1 ? consRedux.selectedConsumptionDetails[0].consumptionId : '';
    const palletId = consRedux.selectedConsumptionDetails.length === 1 ? consRedux.selectedConsumptionDetails[0].palletId : '';
    const operationId = consRedux.currentActivity[0].operationId;
    

    const handleYes = async () => {
        dispatch(setModified(true));
        console.log(new Date().toISOString(), "modal consumption-issuing handleYes");
        tryCatchBootbox(async () => {
            if(consRedux.selectedConsumptionDetails.length !== 1 || consRedux.currentActivity.length !== 1){
                // eslint-disable-next-line no-throw-literal
                throw("Error: consumptionId or operationId is not valid");
            }
            await(returnPallet(consumptionId, qtyRemaining));
            dispatch(closeModal());
            dispatch(getActivityAndConsumptionDetailsByOperationIdRedux(operationId) as any);
        });
    };

    const handleReprint = () => {
        tryCatchBootbox(async () => {
            if(consRedux.selectedConsumptionDetails.length !== 1 || consRedux.currentActivity.length !== 1){
                // eslint-disable-next-line no-throw-literal
                throw("Error: consumptionId or operationId is not valid");
            }
            await(returnPallet(consumptionId, qtyRemaining));
            dispatch(
                showModalWithPalletsByGuid({
                    pallets: [Guid.parse(palletId)],
                    modalType: ModalType.Reprint,
                    callerModalType: ModalType.None
                }) as any
            );
            dispatch(getActivityAndConsumptionDetailsByOperationIdRedux(operationId) as any);
        });
    }

    return (
        <React.Fragment>
            <div className="modal-header">
                <h5>{translateString("return", aplSettings.culture)}</h5>
                <button
                    type="button"
                    className="close"
                    onClick={() => {
                        dispatch(closeModal());
                    }}
                >
                    <span aria-hidden="true" className="text-danger">
                        ×
                    </span>
                    <span className="sr-only">Close</span>
                </button>
            </div>
            <div className="modal-body">
                <div>
                    {translateString("areyousureyouwanttoreturnSSCC", aplSettings.culture)} {modalPltsRedux.pallets.map(x => x.sscc).join(", ")}?
                </div>

                <br />

                <label className="margin-bottom-02em" htmlFor="consumption-return-remaining">
                    {translateString("quantityRemaining", aplSettings.culture)}
                </label>
                <input
                    type="number"
                    className="form-control "
                    id="consumption-return-remaining"
                    aria-describedby="consumption-return-remaining"
                    name="consumption-return-remaining"
                    autoComplete="on"
                    value={qtyRemaining}
                    onChange={e => {
                        updateByRemaining(e.currentTarget.valueAsNumber);
                    }}
                />

                <label className="margin-bottom-02em" htmlFor="consumption-return-consumed">
                    {translateString("quantityConsumed", aplSettings.culture)}
                </label>
                <input
                    type="number"
                    className="form-control "
                    id="consumption-return-consumed"
                    aria-describedby="consumption-return-consumed"
                    name="consumption-return-consumed"
                    autoComplete="on"
                    value={actualQty - qtyRemaining}
                    onChange={e => {
                        updateByConsumed(e.currentTarget.valueAsNumber);
                    }}
                />
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    id="btn-consumption-return-close"
                    onClick={() => {
                        dispatch(closeModal());
                    }}
                >
                    {translateString("close", aplSettings.culture)}
                </button>
                <button type="button" className="btn btn-primary" id="btn-consumption-return-reprint" onClick={handleReprint}>
                    {translateString("reprint", aplSettings.culture)}
                </button>
                <button type="button" className="btn btn-primary" id="btn-consumption-return-ok" onClick={handleYes}>
                    {translateString("inBoundBtnOk", aplSettings.culture)}
                </button>
            </div>
        </React.Fragment>
    );
}
